/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* istanbul ignore file */
import * as Survey from "survey-react";
import { PersonRequest } from "@plinknz/tah-website-elements";

import { EventType, GrantPayload } from "../../config/forms";
import { collapseSurrogate } from "../../service/forms/config-generics/personal-details";

import { getPersonalChanges } from "../svg/member";
import { createSVG, createText } from "../svg/svg";

import { TunaWanangaSourceData } from "./tuna-wananga-types";

function conditionDetails({
  condition,
  details,
}: {
  condition: "Āe" | "Kāo";
  details: string;
}) {
  return condition === "Āe" ? details : condition;
}

function generateSVG({
  member,
  data,
}: {
  member: PersonRequest;
  data: TunaWanangaSourceData;
}) {
  const heading = `${EventType.KirihimeteWhanau} Application`;
  const personalLines = getPersonalChanges({
    ...data,
    member,
  });

  const {
    attendeeAllergies,
    attendeeAllergyDetails,
    mediaRelease,
    signed,
  } = data;

  const lines = [...personalLines];

  lines.push(
    { heading: "Details" },
    {
      label: "Allergies",
      text: conditionDetails({
        condition: attendeeAllergies,
        details: attendeeAllergyDetails,
      }),
    },
    { label: "Media Release", text: mediaRelease }
  );

  let index = 2;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const genericData = data as any;
  while (genericData[`attendee${index - 1}Additional`] === "Āe") {
    const attendee = `attendee${index}`;
    lines.push(
      { heading: `Attendee ${index}` },
      { label: "Name", text: genericData[`${attendee}Name`] },
      { label: "Age", text: genericData[`${attendee}Age`] },
      {
        label: "Allergies",
        text: conditionDetails({
          condition: genericData[`${attendee}Allergies`],
          details: genericData[`${attendee}AllergyDetails`],
        }),
      }
    );
    index += 1;
  }

  lines.push({ src: signed });

  const svg = createSVG({ lines, heading });
  const text = createText({ lines, heading });

  return { svg, text };
}

export function transformKirihimeteWhanauData(
  survey: Survey.ReactSurveyModel,
  member: PersonRequest
): GrantPayload {
  const surveyData = survey.data;
  const data = collapseSurrogate(surveyData);
  const now = new Date().getTime();
  const tenant = process.env.TAH_TENANT;
  const { svg, text } = generateSVG({ data, member });

  const payloadData: GrantPayload = {
    data: {
      event: {
        eventDescription: EventType.KirihimeteWhanau,
        eventDate: now,
      },
      interaction: {
        interaction: svg,
        interactionDate: now,
      },
      email: {
        name: `${data.firstName} ${data.surname}`,
        email: data.email,
        message: text,
      },
    },
    targetId: data.id || member.id,
    recaptcha: null,
    tenant,
  };

  return payloadData;
}
